import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class PireausBankIntegrations  {
    _originalTypeClassName = "zERP.BO.PireausBankIntegrations";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
PireausBankIntegrations.translate = translateService;
}
this.PireausBankIntegrationsKey = null;
this._key = this.PireausBankIntegrationsKey = 0; 
}

static translate: TranslateService;
_key: any;
private _PireausBankIntegrationsKey:any;
get PireausBankIntegrationsKey(): any {
    return this._PireausBankIntegrationsKey;
  }
set PireausBankIntegrationsKey(value: any) {
    this._PireausBankIntegrationsKey = value;
    this._key = value;
  }

static GenerateHeader(doc: any,recordId: any,date: any,transactions: any,amount: any,entity: any,contractCode: any): any{doc.CstmrCdtTrfInitn.GrpHdr = {
}
;
doc.CstmrCdtTrfInitn.GrpHdr.MsgId = recordId;
doc.CstmrCdtTrfInitn.GrpHdr.CreDtTm = date;
doc.CstmrCdtTrfInitn.GrpHdr.NbOfTxs = Joove.Common.safeNumber(transactions) + "";
console.info("Total amount before rounding: " + Joove.Common.safeNumber(amount));
let roundedValue = numeral(Joove.Common.mathRound(amount, 2)).format("F2", "en-US");
console.info("Total amount after rounding: " + roundedValue);
doc.CstmrCdtTrfInitn.GrpHdr.CtrlSum = CLMS.Framework.Decimal.Parse(roundedValue);
console.info("Finally doc.CstmrCdtTrfInitn.GrpHdr.CtrlSum: " + Joove.Common.safeNumber(doc.CstmrCdtTrfInitn.GrpHdr.CtrlSum));
doc.CstmrCdtTrfInitn.GrpHdr.InitgPty = {
}
;
doc.CstmrCdtTrfInitn.GrpHdr.InitgPty.Nm = entity?.Name;
doc.CstmrCdtTrfInitn.GrpHdr.InitgPty.Id = {
}
;
doc.CstmrCdtTrfInitn.GrpHdr.InitgPty.Id.OrgId = {
}
;
let orgId;
orgId.Id = contractCode;
doc.CstmrCdtTrfInitn.GrpHdr.InitgPty.Id.OrgId.Othr = [orgId];
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.PireausBankIntegrationsKey == null || $this.PireausBankIntegrationsKey == 0;
            }


}